export default {"src":"/_next/static/media/map-with-lines.617df4eb.svg","height":504,"width":563};